import { render, staticRenderFns } from "./TermsConditionsDrivers.vue?vue&type=template&id=a7bdf19a&scoped=true&"
var script = {}
import style0 from "./TermsConditionsDrivers.vue?vue&type=style&index=0&id=a7bdf19a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7bdf19a",
  null
  
)

export default component.exports